import PortrateGridController from './PortrateGridController';
import LandscapeGridController from './LandscapeGridController';
import { Graphics } from 'pixi.js';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { isDesktop } from 'react-device-detect';

class MainGridController {
	isGrid = true;
	currentGrid = null;
	origins = {};
	debug = null;
	portrate = null;
	landscape = null;
	background = null;
	constructor(vc, conf) {
		// console.log({ conf });
		if (conf.vc !== undefined) {
			this.vc = vc[conf.vc];
			this.gridConfig = conf.grid;
		} else {
			this.vc = vc;
			this.gridConfig = conf;
		}
		if (conf.background) {
			this.background = {
				element: this.vc[conf.background.element],
				config: conf.background
			};
		}
		if (conf.grid) {
			if (conf.grid.background) {
				this.background = {
					element: this.vc[conf.grid.background.element],
					config: conf.grid.background
				};
			}
		}
		this.vc.position.set(0, 0);

		this.debug = new Graphics();
		this.debug = null;
		this.origins = this.generateOrigins(this.gridConfig);

		if (this.debug) {
			this.vc.addChild(this.debug);
		}

		//vc,origins, conf,debug
		this.portrate = new PortrateGridController(
			this.vc,
			this.origins,
			this.gridConfig,
			this.debug
		);

		this.landscape = new LandscapeGridController(
			this.vc,
			this.origins,
			this.gridConfig,
			this.debug
		);
	}

	generateOrigins(gridConfig) {
		let origins = [];
		if (gridConfig.main) {
			for (let index = 0; index < gridConfig.main.length; index++) {
				const element = gridConfig.main[index];
				origins[element.name] = this.processElement(element);
			}
		}
		if (gridConfig.portrate && (window.isMobile || window.isTablet)) {
			for (let index = 0; index < gridConfig.portrate.length; index++) {
				const element = gridConfig.portrate[index];
				origins[element.name] = this.processElement(element);
			}
		}
		if (gridConfig.landscape && (window.isMobile || window.isTablet)) {
			for (let index = 0; index < gridConfig.landscape.length; index++) {
				const element = gridConfig.landscape[index];
				origins[element.name] = this.processElement(element);
			}
		}
		// console.log({ origins });
		return origins;
	}

	processElement(element) {
		let bounds = null;
		if (element.type === undefined) {
			let current = this.vc[element.name];
			if (current != null) {
				current.position.set(0, 0);
				if (element.bounds) {
					bounds = element.bounds;
				} else {
					current.scale.set(1, 1);
					bounds = current.getBounds();
				}
			}
		} else {
			let grid = this.generateGrid(element);
			this.vc[element.name] = grid;
			bounds = grid.getBounds();
		}

		return bounds;
	}

	generateGrid(element) {
		let grid = null;
		let origins = this.generateOrigins(element.config);

		switch (element.type) {
			case 'PortrateGridController':
				grid = new PortrateGridController(
					this.vc,
					origins,
					element.config,
					this.debug
				);
				break;
			case 'LandscapeGridController':
				grid = new LandscapeGridController(
					this.vc,
					origins,
					element.config,
					this.debug
				);
				break;

			default:
				throw new Error('type not found  ' + element.type);
		}
		return grid;
	}

	resize(w, h) {
		if (this.gridConfig.name === 'WinInfoViewGrid') {
			this.gridConfig.widthLocal = w;
			this.gridConfig.heightLocal = h;
		}
		if (w === undefined || h === undefined) {
			return;
		}
		if (this.debug) {
			this.debug.clear();
			this.debug.beginFill(0xffff00, 0);
		}
		let APP_WIDTH = GameConfigs.APP_WIDTH;
		let APP_HEIGHT = GameConfigs.APP_HEIGHT;

		let scale = Math.min(w / APP_WIDTH, h / APP_HEIGHT);
		let localW = APP_WIDTH * scale;
		let localH = APP_HEIGHT * scale;
		let localX = (w - localW) / 2;
		let localY = (h - localH) / 2;
		if (this.debug) {
			this.debug.lineStyle(6, 0xff0000);
		}
		if (this.background) {
			this.resizeBackground(0, 0, w, h);
			// this.resizeBackground(localX, localY, localW, localH);
		}

		if (window.isMobile || window.isTablet) {
			if (w < h) {
				this.drawRect(0, 0, w, h);
				this.portrate.resize(0, 0, w, h);
			} else {
				this.drawRect(localX, localY, localW - 6, localH - 6);
				this.landscape.resize(localX, localY, localW, localH);
			}
		} else {
			//this.drawRect(localX, localY, localW - 6, localH - 6);
			this.landscape.resize(localX, localY, localW, localH);
			// if (this.background) {
			//     console.log({ localW, localH })
			//     this.background.element.width = localW;
			//     this.background.element.height = localH;
			// }
		}
	}

	resizeBackground(x, y, w, h) {
		if (this.background.element.resizeGrid) {
			this.background.resizeGrid(0, 0, w, h);
		} else {
			let conf = this.background.config.main;
			if (!isDesktop) {
				if (this.background.config.portrate !== undefined) {
					if (w < h) {
						conf = this.background.config.portrate;
					}
				}
				if (this.background.config.landscape !== undefined) {
					if (w >= h) {
						conf = this.background.config.landscape;
					}
				}
			}

			// if (w < h) {
			// 	if (this.background.config.portrate !== undefined) {
			// 		conf = this.background.config.portrate;
			// 	}
			// } else {
			// 	if (this.background.config.landscape !== undefined) {
			// 		conf = this.background.config.landscape;
			// 	}
			// }
			let height = h;
			let width = w;

			if (conf.height) {
				height = h * (conf.height / 100);
			}
			if (conf.width) {
				width = w * (conf.width / 100);
			}
			this.background.element.width = width;
			this.background.element.height = height;

			switch (conf.align) {
				case 'bottom':
					this.background.element.y = h - height;
					break;
				default:
					break;
			}
		}
	}

	drawRect(x, y, w, h) {
		if (this.debug) {
			this.debug.drawRect(x, y, w, h);
		}
	}
}

export default MainGridController;
